import { render } from "./QRCIcon.vue?vue&type=template&id=15e4b2b9&ts=true"
import script from "./QRCIcon.vue?vue&type=script&lang=ts"
export * from "./QRCIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__